import { wget } from 'lodash';

function isReferredByGroup(referral, groupId) {
  return groupId && groupId === wget(referral, 'referred_by_group.id');
}

export default isReferredByGroup;
